export const trackingEventPayments = "payments";
export const trackingEventActionsForPayments = {
    stripeSuccess: "stripeSuccess",
};
//# sourceMappingURL=payments.js.map